import { Breadcrumb } from '../../../components/Breadcrumb';
import { PageHeader } from '../../../components/PageHeader';
import { PageHeading } from '../../../components/PageHeading';
import { useAuth } from '../../../contexts/auth-context';
import { useTranslation } from '../../../contexts/translation-context';
import { ConnectionsActions } from '../../telemetry/components/ConnectionsActions';
import { ConnectionsPanel } from '../../telemetry/components/ConnectionsPanel';
import { useCarrierPortalSupplier } from '../CarrierPortalCarrierContext';

/** A carrier's own tracking connections, and the vehicles they report with their truck links. */
export const CarrierPortalTrackingPage = () => {
  const { carrierId } = useCarrierPortalSupplier();
  const { i18n } = useTranslation();
  const { me } = useAuth();

  // A driver may follow the trucks, but only a dispatcher may rotate the carrier's provider key.
  const isDispatcher = me?.carriers.some((c) => c.id === carrierId && c.role === 'CarrierDispatcher') ?? false;
  const title = i18n('carrierPortal.liveTracking.liveTracking');

  return (
    <>
      <PageHeader title={title} />

      <PageHeading
        noMarginBottom
        leftSide={<Breadcrumb currentItem={title} />}
        rightSide={<ConnectionsActions party={{ carrierId }} canWrite={isDispatcher} />}
      />

      <div className="grid gap-4 p-7">
        <ConnectionsPanel party={{ carrierId }} canWrite={isDispatcher} />
      </div>
    </>
  );
};
